module.exports = __webpack_public_path__ + "static/media/logo.7b20c1f4.svg";